import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FbVideo from './FbVideo';

export default class EmbedVideo extends React.Component {
  constructor() {
    super();

    this.state = {
      isPlayerVisible: false,
      isYtPlayerClickedOnce: false
    };

    this.ytPlayerId = 'vup-card-youtube-player-' + _.uniqueId();
    this.isYtPlayerClickedOnce = false;
    this.onYoutubePlayerStateChange = this.onYoutubePlayerStateChange.bind(this);
  }

  componentDidMount() {
    const shouldCaptureYtVideoClicks = this.props.kind === 'youtube';
    if (shouldCaptureYtVideoClicks) {
      window.onYouTubeIframeAPIReady = () => {
        this.player = new YT.Player(this.ytPlayerId);
        if (this.player) {
          this.player.addEventListener('onStateChange', this.onYoutubePlayerStateChange);
        }
      };

      this.loadYoutubeIframeScript();
    }

    this.setState({
      isPlayerVisible: true
    });
  }

  getYtVidUrl() {
    const autoplayConcatenator = (this.props.url.indexOf('?') === -1 ? '?' : '&');
    return this.props.url + autoplayConcatenator + 'autoplay=1&rel=0&controls=0&modestbranding=1&showinfo=0&enablejsapi=1';
  }

  onYoutubePlayerStateChange(event) {
    const isPausedOrResumed = event.data === YT.PlayerState.PAUSED || (event.data === YT.PlayerState.PLAYING && this.isYtPlayerClickedOnce);
    this.isYtPlayerClickedOnce = this.isYtPlayerClickedOnce || isPausedOrResumed;

    if (isPausedOrResumed) {
      this.onYtPlayerClick();
    }
  }

  onYtPlayerClick() {
    const {onPlayerClick} = this.props;
    if (onPlayerClick) {
      onPlayerClick();
    }
  }

  onNativePlayerClick(e) {
    const {onPlayerClick} = this.props;
    if (onPlayerClick) {
      onPlayerClick();
    }

    if (e.target.paused) {
      e.target.play();
    } else if (e.target.pause) {
      e.target.pause();
    }
  }

  render() {
    if (!this.state.isPlayerVisible) {
      return null;
    }

    const {url, poster, kind, onPlayerClick} = this.props;
    switch (kind) {
      case 'upload':
      default:
        return (
          <video
            src={url}
            autoPlay
            onClick={this.onNativePlayerClick.bind(this)}
            poster={poster} />);
      case 'youtube':
        return (
          <iframe src={this.getYtVidUrl()}
                  id={this.ytPlayerId}
                  title={this.ytPlayerId}
                  frameBorder="0" />);
      case 'facebook':
        return (
          <FbVideo url={url} onPlayerClick={onPlayerClick}/>);
    }
  }

  loadYoutubeIframeScript() {
    this.loadScript('https://www.youtube.com/iframe_api');
  }

  loadScript(src) {
    const head = document.getElementsByTagName('head')[0],
      script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = 'text/javascript';
    script.src = src;
    head.appendChild(script);
  }
}

EmbedVideo.displayName = 'FbVideo';

EmbedVideo.propTypes = {
  url: PropTypes.string.isRequired,
  kind: PropTypes.string,
  poster: PropTypes.string,
  onPlayerClick: PropTypes.func
};

EmbedVideo.defaultProps = {
  onPlayerClick: () => {
  }
};
